import { useEffect, useState } from "react";
import { TextView } from "../../view-form-components/text-view";
import { MultiFileDownloadView } from "../../view-form-components/file-view";
import { api } from "../../../redux/apis/api";
import ShareModal from "../../modal/share-modal";

const CustomerActivityViewModal = ({
  isOpen = false,
  onClose = () => {},
  onDeleteFnc = () => {},
  selectID,
  deleteDisable = true,
  shareButton = true,
}) => {
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const [shareModalShow, setShareModalShow] = useState(false);

  const fetchData = () => {
    setLoading(true);
    api
      .post(`/customer/activity/read`, {
        id: selectID,
      })
      .then((res) => {
        setData(res.data.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error("API Error:", err);
        setLoading(false);
      });
  };

  useEffect(() => {
    if (selectID && isOpen === true) {
      fetchData();
    }
  }, [selectID, isOpen]);

  return (
    <>
      <ShareModal
        isOpen={shareModalShow}
        onClose={() => {
          setShareModalShow(false);
        }}
        moduleName="customer_activity"
        modulelabel="customer_activity"
        selectID={selectID}
        viewType={"modal"}
      />
      {isOpen && (
        <div
          className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center"
          onClick={handleOverlayClick}
        >
          <div
            className="bg-white rounded-lg shadow-lg max-w-[50rem] w-full md:p-8 p-4 relative"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="flex justify-between items-center mb-5 sticky top-0 bg-background pb-2 z-10">
              <h2 className="text-xl font-semibold capitalize">
                customer activity - view
              </h2>
              <div className="flex gap-3 items-center">
                {shareButton && (
                  <button
                    onClick={() => {
                      setShareModalShow(true);
                      onClose();
                    }}
                    className="px-4 py-1 bg-primary border-[2px] border-primary text-white rounded"
                  >
                    share
                  </button>
                )}
                <button
                  onClick={() => onClose()}
                  type="button"
                  className="px-4 py-1 border-[2px] border-errorColor text-errorColor rounded"
                >
                  Cancel
                </button>
                {deleteDisable && (
                  <button
                    onClick={onDeleteFnc}
                    type="button"
                    className="px-4 py-1 border-[2px] border-errorColor bg-errorColor text-white rounded"
                  >
                    Delete
                  </button>
                )}
              </div>
            </div>
            <section className="overflow-auto w-full h-[60vh]">
              <section className="w-full max-w-[40rem]">
                <div className="px-2">
                  <TextView label={"customer"} value={data?.customer?.name} />
                </div>
                <div className="px-2">
                  <TextView
                    label={"ffAdminUsers"}
                    value={data?.ffAdminUsers?.name}
                  />
                </div>
                <div className="px-2">
                  <TextView label={"Title"} value={data?.title} />
                </div>
                <div className="px-2">
                  <TextView label={"Description"} value={data?.description} />
                </div>
                <div className="px-2">
                  <TextView label={"Type"} value={data?.type} />
                </div>
                <div className="px-2">
                  <h1 className="text-lightGreyText font-fw_400 text-fs_16 capitalize">
                    File
                  </h1>
                  <MultiFileDownloadView
                    urls={data?.file?.length > 0 ? data?.file : []}
                  />
                </div>
                <div className="px-2">
                  <TextView label={"Status"} value={data?.status} />
                </div>
                <div className="px-2">
                  <TextView
                    label={"activity date"}
                    value={data?.activity_date}
                  />
                </div>
                <div className="px-2">
                  <TextView
                    label={"activity time"}
                    value={data?.activity_time}
                  />
                </div>
                <div className="px-2">
                  <TextView
                    label={"Created By"}
                    value={data?.createdBy?.name}
                  />
                </div>
              </section>
            </section>
          </div>
        </div>
      )}
    </>
  );
};

export default CustomerActivityViewModal;
